<template>
  <v-container fluid>
    <v-layout class="hide-on-print" row wrap>
      <v-flex xs12>
        <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
          <h3 class="font-weight-bold">{{ certification_data.type }} Certification Details
            ({{ certification_data.status }})</h3>
        </v-flex>
        <v-card>
          <v-tabs
              background-color="primary"
              dark
              fixed-tabs
              height="40"
              v-model="tab">
            <v-tab href="#certification-detail">
              <v-icon class="mr-2" size="15">mdi-account-card-details</v-icon>
              Certification Detail
            </v-tab>
            <v-tab href="#history">
              <v-icon class="mr-2" size="15">mdi-history</v-icon>
              Certification History
            </v-tab>
            <v-tabs-items v-model="tab">
              <v-tab-item value="certification-detail">
                <v-card class="pb-4" :loading="loading" flat>
                  <v-card-text class="mt-4">
                    <v-layout row wrap>

                      <confirmation-header-text class="ml-2"
                                                icon="mdi-alpha-c-box"
                                                text="Certification Details"/>

                      <v-flex xs3 class="pl-4">
                        <list-item-detail :sub_title="certification_data.country"
                                          :title="certification_data.type + ' country'"/>
                      </v-flex>

                      <v-flex xs3>
                        <list-item-detail :sub_title="certification_data.office.name"
                                          :title="certification_data.type + ' point'"/>
                      </v-flex>
                      <v-flex xs3>
                        <list-item-detail :sub_title="certification_data.date_of_entry"
                                          :title="'Date of ' +certification_data.type"/>
                      </v-flex>
                      <v-flex v-if="type === 'Arrival'" xs3>
                        <list-item-detail :sub_title="certification_data.purpose_of_visit"
                                          title="Purpose of visit"/>
                      </v-flex>

                      <v-flex xs3>
                        <list-item-detail :sub_title="certification_data.reason_of_certification"
                                          title="Reason for certification"/>
                      </v-flex>


                      <v-flex xs3 v-if="certification_data.proof">
                        <file-list-item-detail
                            :src="certification_data.proof"
                            :sub_title="'Proof of '+ (certification_data.type && certification_data.type.toLowerCase())">
                        </file-list-item-detail>
                      </v-flex>

                      <v-flex xs12>
                        <v-divider class="my-3"/>
                      </v-flex>


                      <v-flex class=" pb-1 d-flex justify-space-between " lg12 md12 sm12>

                        <confirmation-header-text class="ml-2"
                                                  icon="mdi-account"
                                                  text="Personal Details"/>
                        <!--                        <v-btn-->
                        <!--                            @click="viewTravellerData"-->
                        <!--                            color="primary"-->
                        <!--                            dark-->
                        <!--                            dense-->
                        <!--                            small-->
                        <!--                            text>-->
                        <!--                          View Details-->
                        <!--                        </v-btn>-->
                      </v-flex>

                      <v-flex sm3 xs12 class="pl-4">
                        <list-item-detail
                            title="Name"
                            :sub_title="certification_data.traveller.name">
                        </list-item-detail>
                      </v-flex>

                      <v-flex sm3 xs12>
                        <list-item-detail :sub_title="certification_data.traveller.dob" title="DOB">
                        </list-item-detail>
                      </v-flex>

                      <v-flex sm3 xs12>
                        <file-list-item-detail :avatar="true"
                                               :src="certification_data.traveller.image"
                                               sub_title="User Image">
                        </file-list-item-detail>
                      </v-flex>


                      <v-flex sm3 xs12>
                        <list-item-detail :sub_title="certification_data.traveller.gender"
                                          title="Gender"/>
                      </v-flex>

                      <v-flex sm3 xs12 class="pl-4">
                        <list-item-detail :sub_title="certification_data.traveller.occupation"
                                          title="Occupation">
                        </list-item-detail>
                      </v-flex>


                      <v-flex sm4 xs12>
                        <list-item-detail title="Contact Number"
                                          :sub_title="certification_data.traveller.contact_number"
                        >
                        </list-item-detail>
                      </v-flex>
                      <v-flex xs12 v-if="certification_data.payment_detail" class="my-3">
                        <payment-detail
                            :payment_detail="certification_data.payment_detail" :paid="certification_data.paid"
                        />
                      </v-flex>
                      <v-flex xs12 v-else>
                        <header-text class="ml-2"
                                     text="Payment details"
                                     icon="mdi-alpha-p-box"
                        />
                        <v-layout row wrap class="pl-2">
                          <v-flex xs3>
                            <list-item-detail title="Amount (USD)"
                                              :sub_title="certification_data.cost"
                            />
                          </v-flex>
                          <v-flex xs3 v-if="certification_data.exempt_cost > 0">
                            <list-item-detail title="Exempt cost (USD)"
                                              :sub_title="certification_data.exempt_cost"
                            />
                          </v-flex>
                          <v-flex xs3 v-if="certification_data.voucher_number">
                            <list-item-detail title="Voucher number"
                                              :sub_title="certification_data.voucher_number"
                            />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-footer class="sticky" color="blue darken-1" fixed height="auto">
                        <v-layout row wrap
                                  v-if="!certification_data.is_verified && !certification_data.approve_rejected">
                          <v-spacer/>
                          <v-btn
                              @click="verify"
                              color="blue ml-2"
                              class="text-white"
                              v-if="certification_data.can_verify"
                          >
                            Verify Certification
                          </v-btn>
                          <v-btn
                              @click="reject"
                              color=" red lighten-1 ml-2"
                              v-if="certification_data.can_verify"
                          >
                            Reject
                          </v-btn>
                        </v-layout>
                        <v-layout row wrap v-else>
                          <v-spacer/>

                          <v-btn
                              @click="generateTippani"
                              class="white--text"
                              color="blue"
                              v-if="!certification_data.paid && !certification_data.tippani_generated && certification_data.can_approve && !certification_data.approve_rejected"
                          >
                            Generate Tippani
                          </v-btn>

                          <v-btn
                              @click="print('tippani')"
                              class="white--text"
                              color="blue"
                              v-if="certification_data.tippani_generated && certification_data.can_approve && !certification_data.approve_rejected"
                          >
                           Print Tippani
                          </v-btn>

                          <v-btn
                              @click="costExemptedDialog = true"
                              color="blue ml-2"
                              class="text-white"
                              v-if="!certification_data.tippani_generated && !certification_data.cost_exempted && certification_data.can_approve && !certification_data.approve_rejected"
                          >
                            Exempt cost
                          </v-btn>
                          <v-btn
                              @click="generateVoucher"
                              color="blue ml-2"
                              class="text-white"
                              v-if="certification_data.tippani_generated && !certification_data.voucher_generated && certification_data.can_approve"
                          >
                            Generate voucher
                          </v-btn>
                          <v-btn
                              @click="print('voucher')"
                              color="blue ml-2"
                              class="text-white"
                              v-if="certification_data.voucher_generated"
                          >
                            Print voucher
                          </v-btn>
                          <v-btn
                              @click="payManually"
                              color="blue ml-2"
                              class="text-white"
                              v-if="certification_data.voucher_generated && !certification_data.paid && certification_data.can_approve "
                          >
                            Pay manually
                          </v-btn>
                          <v-btn
                              @click="checkPaymentStatus"
                              color="blue ml-2"
                              class="text-white"
                              v-if="certification_data.voucher_generated && !certification_data.paid && certification_data.malanika_active && certification_data.can_approve"
                          >
                            Check payment status
                          </v-btn>
                          <v-btn
                              @click="reject"
                              color=" red lighten-1 ml-2"
                              v-if="certification_data.paid && !certification_data.approve_rejected && certification_data.can_approve"
                          >
                            Reject
                          </v-btn>
                          <v-btn
                              class="ml-2"
                              @click="approve"
                              color="primary"
                              v-if="certification_data.paid && !certification_data.approve_rejected && certification_data.can_approve"
                          >
                            Approve
                          </v-btn>
                        </v-layout>
                      </v-footer>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item value="history">
                <v-card :loading="loading" flat>
                  <visa-history :history="certification_data.history" :certification="true"
                                :show_load_more="false"/>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-card>
      </v-flex>
      <v-flex v-if="!certification_data.voucher_number" xs12>
        <v-dialog
            class="hide-on-print"
            persistent
            width="800"
            v-model="tippaniDialog">
          <v-card class="hide-on-print">
            <v-toolbar color="blue darken-3" dark v-if="step === 1">
              <v-toolbar-title>Generate tippani</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="pt-4">
              <div :class="{'hide-on-block':step === 2}">
                <v-layout row wrap>
                  <v-flex xs12>
                    <div id="editor"></div>
                  </v-flex>
                </v-layout>
              </div>
              <div v-if="step === 2">
                <non-visa-tippani-print-content/>
              </div>
            </v-card-text>
            <v-card-actions class="mt-8">
              <v-spacer/>
              <v-btn @click="cancel" color="error">Cancel</v-btn>
              <v-btn @click="next" color="primary" v-if="step === 1">Next</v-btn>
              <v-btn @click="save" color="primary" v-if="step === 2">Save</v-btn>
              <v-btn @click="print('tippani')" color="primary" v-if="step === 2">Print</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <v-flex v-if="certification_data.paid" xs12>
        <v-dialog v-model="approveModal" width="700px" persistent>
          <v-card>
            <v-toolbar color="blue darken-3" dark>
              <v-toolbar-title>Approve {{ type && type.toLowerCase() }} certification</v-toolbar-title>
            </v-toolbar>

            <v-card-text class="pt-3">
              <v-form ref="approveRef">
                <v-textarea
                    label="Remarks"
                    outlined
                    v-model="approveData.remarks"
                />
                <multiple-file-upload v-model="approveData.files"/>

              </v-form>

            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <v-btn @click="cancel" color="warning">Cancel</v-btn>
              <v-btn @click="approveCertification" color="primary">Approve</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
    <cost-exemption-dialog
        v-model="costExemptedDialog"
        v-if="!certification_data.tippani_generated && costExemptedDialog"
        :url="'exempt-cost/'+certification_data.submission_no"
        :payment-detail="certification_data.payment_detail"
        @exempted="exempted"
    />
    <non-visa-tippani-print-content class="show-on-print"
                                    v-if="printType === 'tippani'"/>
    <manual-payment-dialog v-model="manualDialog"
                           :url="'pay-track-manually/'+certification_data.submission_no"
                           @paid="paid"/>

    <voucher-content
        class="show-on-print"
        v-if="printType ==='voucher'"
        :type="'non_visa_certifications'"
        :data="certification_data"
    />
    <v-dialog v-model="rejectModal" width="700px" persistent>
      <v-card>
        <v-toolbar color="blue darken-3" dark>
          <v-toolbar-title>Reject {{ type && type.toLowerCase() }} certification</v-toolbar-title>
        </v-toolbar>

        <v-card-text class="pt-4">
          <v-form ref="rejectRef">
            <v-textarea
                :rules="[rules.required]"
                label="Remarks"
                outlined
                v-model="rejectData.remarks"
            />
            <multiple-file-upload v-model="rejectData.files"/>
          </v-form>

        </v-card-text>
        <v-card-actions>
          <v-spacer/>

          <v-btn @click="cancel" color="warning">Cancel</v-btn>
          <v-btn @click="rejectTransfer" color="primary">Reject</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {
  APPROVE_VISA_CERTIFICATION,
  CHECK_VISA_CERTIFICATION_PAYMENT_STATUS, GENERATE_VOUCHER,
  GET_VISA_CERTIFICATION,
  REJECT_VISA_CERTIFICATION,
  SAVE_VISA_CERTIFICATION_TIPPANI
} from "../../../store/action-type";
import ListItemDetail from "../../../components/ListItemDetail";
import HeaderText from "../../../components/HeaderText";
import ConfirmationHeaderText from "../../../components/ConfirmationHeaderText";
import FileListItemDetail from "../../../components/FileListItemDetail";
import DialogFile from "../../../components/FileDisplay";
import FileInput from "../../../components/FileInput";
import MultipleFileUpload from "../../../components/MultipleFileUpload";
import VoucherContent from "../../../components/VoucherContent";
import Quill from 'quill'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import {SET_CERTIFICATION_PRINT_CONTENT, SET_CERTIFICATION_TYPE,} from "../../../store/mutation-type";
import TransferTippaniPrint from "../../../components/tippani/TransferTippaniPrint";

import {validationMixin} from '../../../mixins/validationMixin'
import CertificationTippaniPrint from "../../../components/tippani/CertificationTippaniPrint";
import PaymentDetail from "../../../components/PaymentDetail";
import ManualPaymentDialog from "../../../components/dialogs/ManualPaymentDialog";
import NonVisaTippaniPrintContent from "../../../components/tippani/NonVisaTippaniPrintContent";
import CostExemptionDialog from "../../../components/dialogs/CostExemptionDialog";
import VisaHistory from "../../../views/visa/visa-request/VisaHistory";

export default {
  name: "NonVisaCertificationView",
  components: {
    ListItemDetail,
    HeaderText,
    DialogFile,
    TransferTippaniPrint,
    FileInput, ConfirmationHeaderText,
    FileListItemDetail,
    MultipleFileUpload,
    PaymentDetail,
    VoucherContent,
    ManualPaymentDialog,
    NonVisaTippaniPrintContent,
    CostExemptionDialog,
    VisaHistory
  },
  data() {
    return {
      tippaniDialog: false,
      step: 1,
      quill: null,
      approveModal: false,
      rejectModal: false,
      printType: null,
      manualDialog: false,
      approveData: {},
      rejectData: {},
      costExemptedDialog: false,
      tab: null
    }
  },
  mixins: [validationMixin],
  computed: {
    certification_data() {
      return this.$store.state.NonVisaCertification.certificationData;
    },
    type() {
      return this.$store.state.Certification.type;
    }
  },
  methods: {
    viewTravellerData() {
      window.open('/system/travellers-history/view/' + this.certification_data.traveller.id)
    },
    viewVisaDetail() {
      window.open('/system/visa-requests/view/' + this.certification_data.visa.submission_no, '_blank')
    },
    next() {
      this.$store.commit('NonVisaCertification/setTippaniContent', this.quill.root.innerHTML);
      this.step = 2;
    },
    payManually() {
      this.manualDialog = true;
    },
    exempted(data) {
      this.certification_data.cost_exempted = true;
      this.certification_data.exempt_cost = data;
      this.certification_data.cost = this.certification_data.cost - data;
    },
    print(type) {
      this.printType = type;
      setTimeout(() => {
        window.print()
      }, 200)
    },
    approve() {
      this.approveModal = true;
    },
    async approveCertification() {
      if (this.$refs.approveRef.validate()) {
        const formData = new FormData();
        formData.append('remarks', this.approveData.remarks);
        if (this.approveData.files && this.approveData.files.length) {
          let files = this.approveData.files;
          for (let i = 0; i < files.length; i++) {
            formData.append(`files[${i}]`, files[i]);
          }
        }
        try {
          const response = await this.$store.dispatch('NonVisaCertification/approveCertification', formData);
          this.$store.commit('Notification/showSuccess', response.data.message);
          this.approveModal = false;
        } catch (e) {
          this.$store.commit('Notification/showError', 'Something went wrong');
        }
      }
    },
    async rejectTransfer() {
      if (this.$refs.rejectRef.validate()) {
        const formData = new FormData();
        formData.append('remarks', this.rejectData.remarks);
        let files = this.rejectData.files;
        if (files && files.length) {
          for (let i = 0; i < files.length; i++) {
            formData.append(`files[${i}]`, files[i]);
          }
        }
        try {
          const response = await this.$store.dispatch('NonVisaCertification/rejectCertification', formData);
          this.$store.commit('Notification/showSuccess', response.data.message);
          this.rejectModal = false;
        } catch (e) {
          this.$store.commit('Notification/showError', 'Something went wrong');
        }
      }
    },
    reject() {
      this.rejectModal = true;
    },
    async checkPaymentStatus() {
      try {
        await this.$store.dispatch('NonVisaCertification/checkPaymentStatus');
        this.$store.commit('Notification/showSuccess', 'Amount has been paid')
      } catch (e) {
        this.$store.commit('Notification/showError', e.response.data.message)
      }
    },
    async generateVoucher() {
      try {
        await this.$store.dispatch('NonVisaCertification/generateVoucher');
        this.$store.commit('Notification/showSuccess', 'Voucher generated successfully')
      } catch (e) {
        this.$store.commit('Notification/showError', 'Something went wrong');
      }
    },
    async save() {
      await this.$dialog.confirm({
        text: "Are you sure want to save tippani ? (Tippani once save cannot be reverted )",
        actions: {
          false: "No",
          true: {
            text: "Yes",
            handle: async () => {
              try {
                const response = await this.$store.dispatch('NonVisaCertification/saveTippani', this.quill.root.innerHTML);
                this.$store.commit('Notification/showSuccess', response.data.message);
                this.$store.dispatch('NonVisaCertification/getDetails', this.$route.params.id);
                this.tippaniDialog = false;
              } catch (e) {
                this.$store.commit('Notification/showError', 'Something went wrong')
              }
            }
          }
        }
      });
    },
    cancel() {
      if (this.step === 1) {
        this.tippaniDialog = false;
      } else {
        this.step = 1;
      }
      this.approveModal = false;
      this.rejectModal = false;
    },
    paid() {
      this.$store.dispatch('NonVisaCertification/getDetails', this.$route.params.id);
    },
    generateTippani() {
        let tippani = this.certification_data.tippani;
        this.tippaniDialog = true;
        let content = tippani;
        content = content.replace('@cost', this.certification_data.cost);
        content = content.replace('@entry_date', this.certification_data.date_of_entry);
        content = content.replace('@entry_point', this.certification_data.office.name);
        setTimeout(() => {
          if (!this.quill)
            this.quill = new Quill('#editor', {
              theme: 'snow',
              modules: {
                toolbar: [
                  [{header: [1, 2, false]}],
                  ['bold', 'italic', 'underline'],
                ],
              },
            });
          this.quill.root.innerHTML = content;
        }, 100);
    },

    async verify() {
      try {
        await this.$store.dispatch('NonVisaCertification/verifyCertification');
        this.$store.commit('Notification/showSuccess', 'This certification application has been verified')
        this.$store.dispatch('NonVisaCertification/getDetails', this.$route.params.id);
      } catch (e) {
        this.$store.commit('Notification/showError', 'Something went wrong')
      }
    },
  },
  mounted() {
    let type = this.$route.params.type;
    this.$store.commit('NonVisaCertification/setType', type);
    this.$store.dispatch('NonVisaCertification/getDetails', this.$route.params.id);
  }
}
</script>
